// extracted by mini-css-extract-plugin
export var arrows = "_2j-5";
export var decrementer = "_2j-9";
export var disabled = "_2j-3";
export var error = "_2j-1";
export var hiddenText = "_2j-a";
export var incrementer = "_2j-8";
export var input = "_2j-7";
export var inputWrapper = "_2j-0";
export var leadingIcon = "_2j-b";
export var readonly = "_2j-2";
export var regular = "_2j-6";
export var small = "_2j-4";